import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Redirect } from 'react-router-dom';

const PrizesMenu = (props) => {
  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;

  return (
    <div className="container">
      <div className="title-section">Prizes</div>
      <div className="row">
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Prizes</p>
              </div>
              <div className="card-action">
                <Link to="prizes">Prizes</Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Prizes Config</p>
              </div>
              <div className="card-action">
                <Link to="prizesConfig">Prizes Config</Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col l3 m6 s12">
          <div className="card horizontal">
            <div className="card-stacked">
              <div className="card-content">
                <p>Import prizes from file</p>
              </div>
              <div className="card-action">
                <Link to="importPrizes">Import prizes</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.firebase.auth,
  };
};

export default compose(connect(mapStateToProps))(PrizesMenu);
